import { countries } from "src/assets/data";

import { _mock } from "./_mock";
import { _descriptions, _tags } from "./assets";
import { generateDates } from "src/utils/global-functions";

// ----------------------------------------------------------------------
const daysBeforeAndAfter = 4;

export const TOURNAMENT_DETAILS_TABS = [
  { value: "content", label: "Tour Content" },
  { value: "bookers", label: "Booker" },
];

export const TOURNAMENT_SORT_OPTIONS = [
  { value: "latest", label: "latest" },
  //{ value: "popular", label: "Popular" },
  { value: "oldest", label: "oldest" },
];

export const TOURNAMENT_PUBLISH_OPTIONS = [
  {
    value: "published",
    label: "Published",
  },
  {
    value: "draft",
    label: "Draft",
  },
];

export const TOURNAMENT_SERVICE_OPTIONS = [
  { value: "Audio guide", label: "Audio guide" },
  { value: "Food and drinks", label: "Food and drinks" },
  { value: "Lunch", label: "Lunch" },
  { value: "Private tour", label: "Private tour" },
  { value: "Special activities", label: "Special activities" },
  { value: "Entrance fees", label: "Entrance fees" },
  { value: "Gratuities", label: "Gratuities" },
  { value: "Pick-up and drop off", label: "Pick-up and drop off" },
  { value: "Professional guide", label: "Professional guide" },
  {
    value: "Transport by air-conditioned",
    label: "Transport by air-conditioned",
  },
];

const CONTENT = `
<h6>Description</h6>
<br/>
<p>Occaecati est et illo quibusdam accusamus qui. Incidunt aut et molestiae ut facere aut. Est quidem iusto praesentium excepturi harum nihil tenetur facilis. Ut omnis voluptates nihil accusantium doloribus eaque debitis.</p>

<br/>
<br/>
<br/>

<h6>Highlights</h6>
<br/>
<ul>
    <li>A fermentum in morbi pretium aliquam adipiscing donec tempus.</li>
    <li>Vulputate placerat amet pulvinar lorem nisl.</li>
    <li>Consequat feugiat habitant gravida quisque elit bibendum id adipiscing sed.</li>
    <li>Etiam duis lobortis in fames ultrices commodo nibh.</li>
</ul>

<br/>
<br/>
<br/>

<h6>Program</h6>
<br/>
<p><strong>Day 1</strong></p>
<br/>
<p>Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.</p>
<br/>
<p><strong>Day 2</strong></p>
<br/>
<p>Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.</p>
<br/>
<p><strong>Day 3</strong></p>
<br/>
<p>Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.</p>

<br/>
<br/>
<br/>
`;

const BOOKER = [...Array(12)].map((_, index) => ({
  id: _mock.id(index),
  guests: index + 10,
  name: _mock.fullName(index),
  avatarUrl: _mock.image.avatar(index),
}));

export const _tournamentGuides = [...Array(12)].map((_, index) => ({
  id: _mock.id(index),
  name: _mock.fullName(index),
  avatarUrl: _mock.image.avatar(index),
  phoneNumber: _mock.phoneNumber(index),
}));

export const TOURNAMENT_IMAGES = [...Array(16)].map((_, index) =>
  _mock.image.tournament(index)
);

export const TOURNAMENT_MATCHES = [
  /**************************************************** */

  {
    id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b9",
    title: "Player 3 vs Player 4",
    player1: "Player 3",
    player2: "Player 4",
    allDay: false,
    color: "#007b7729",
    description: {
      comptype: "Férfi Egyéni Amatőr",
      grouptable: "1. Csoport",
      court: 1,
      result: "6:7 7:6 14:12",
    },
    start: generateDates(daysBeforeAndAfter)[4] + "T11:30:00+02:00",
    end: generateDates(daysBeforeAndAfter)[4] + "T12:00:00+02:00",
    result: "7-6 4:6 10:8",
    resourceId: "1",
  },
  {
    id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b19",
    title: "Player 2 vs Player 1",
    player1: "Player 2",
    player2: "Player 1",
    allDay: false,
    color: "#007b7729",
    description: {
      comptype: "Férfi Egyéni Amatőr",
      grouptable: "1. Csoport",
      court: 1,
      result: "6:7 7:6 14:12",
    },
    start: generateDates(daysBeforeAndAfter)[4] + "T13:33:58+02:00",
    end: generateDates(daysBeforeAndAfter)[4] + "T15:13:58+02:00",
    result: "7-6 4:6 10:8",
    resourceId: "2",
  },

  {
    id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b18",
    title: "Player 3/Player 5 vs Player 7/Player 10",
    player1: "Player 3/Player 5",
    player2: "Player 7/Player 10",
    allDay: false,
    color: "#007b7729",
    description: {
      comptype: "Férfi Egyéni Amatőr",
      grouptable: "1. Csoport",
      court: 2,
      result: "6:7 7:6 14:12",
    },
    start: generateDates(daysBeforeAndAfter)[4] + "T11:00:00+02:00",
    end: generateDates(daysBeforeAndAfter)[4] + "T12:00:00+02:00",
    result: "3-6 7:6 16:14",
    resourceId: "2",
  },

  {
    id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b10",
    title: "Player 1 vs Player2",
    player1: "Player1",
    player2: "Player 2",
    allDay: false,
    color: "#007b7729",
    description: {
      comptype: "Férfi Egyéni Amatőr",
      grouptable: "1. Csoport",
      court: 3,
      result: "6:7 7:6 14:12",
    },
    start: generateDates(daysBeforeAndAfter)[4] + "T10:00:00+02:00",
    end: generateDates(daysBeforeAndAfter)[4] + "T11:43:58+02:00",
    result: "6-0 2:6 10:8",
    resourceId: "3",
  },
];

const TOURNAMENT_VENUES = [
  //   {
  //     "id": 6,
  //     "name": "Tenisz 23",
  //     "address": "ee",
  //     "view": 1,
  //     "shortName": "T2",
  //     "typeId": 3,
  //     "type": {
  //         "id": 3,
  //         "name": "tennishall",
  //         "image": "",
  //         "status": 1
  //     },
  //     "title": "Tenisz 23"
  // }
  {
    id: 1,
    name: "1. Pálya",
    title: "1. Pálya",
    icon: "public/images/venues_icons/tennis_court.jpg",
    shortName: "T2",
    typeId: 3,
    type: {
      id: 1,
      name: "tennishall",
      image: "",
      status: 1,
    },
  },

  {
    id: 3,
    name: "Füvespálya",
    title: "Füvespálya",
    type: "tennis_court",
    icon: "public/images/venues_icons/tennis_court.jpg",
  },
  {
    id: 4,
    name: "Nagypálya",
    title: "Nagypálya",
    type: "football_court",
    icon: "public/images/venues_icons/football_court.jpg",
  },
  {
    id: 2,
    name: "X. Pálya",
    title: "X. Pálya",
    type: "tennis_court",
    icon: "public/images/venues_icons/tennis_court.jpg",
  },
  {
    id: 6,
    name: "Fekete Pálya",
    title: "Fekete Pálya",
    type: "tennis_court",
    icon: "public/images/venues_icons/tennis_court.jpg",
  },
];

export const _tournaments = [...Array(12)].map((_, index) => {
  const available = {
    startDate: _mock.time(index + 1),
    endDate: _mock.time(index),
  };

  const registrationPeriod = {
    startDate: _mock.time(index + 1),
    endDate: _mock.time(index),
  };

  const avatarUrl = _mock.image.avatar(index);
  const coverUrl = _mock.image.cover(index);

  const publish = index % 3 ? "published" : "draft";

  const destination = countries.map((option) => option.label)[index];

  const tournamentStatuses = [
    "draft",
    "published",
    "applications_open",
    "applications_closed",
    "running",
    "finished",
    "cancelled",
  ];

  const allSports = [
    "tennis",
    "badminton",
    "padel",
    "squash",
    "table_tennis",
    "pickleball",
  ];
  const status = tournamentStatuses[index % tournamentStatuses.length];

  const sports =
    index % 4 === 0
      ? [allSports[index % allSports.length]]
      : [
          allSports[index % allSports.length],
          allSports[(index + 1) % allSports.length],
        ];
  const services = (index % 2 && ["Audio guide", "Food and drinks"]) ||
    (index % 3 && ["Lunch", "Private tour"]) ||
    (index % 4 && ["Special activities", "Entrance fees"]) || [
      "Gratuities",
      "Pick-up and drop off",
      "Professional guide",
      "Transport by air-conditioned",
    ];

  const tournamentGuides =
    (index === 0 && _tournamentGuides.slice(0, 1)) ||
    (index === 1 && _tournamentGuides.slice(1, 3)) ||
    (index === 2 && _tournamentGuides.slice(2, 5)) ||
    (index === 3 && _tournamentGuides.slice(4, 6)) ||
    _tournamentGuides.slice(6, 9);

  let rand = (Math.random() * (4 - 1 + 1)) << 0;

  //const images = _mock.image.tournament(rand);

  const images = TOURNAMENT_IMAGES.slice(rand, 4);
  //const images = TOURNAMENT_IMAGES.slice(index, index + 5);

  const organiser = _mock.fullName(index);
  const judges = _mock.fullName(index);
  const ball = _mock.ball(index);

  const prize = "Trophys, medals, prize money";
  const description =
    "So you have heard about this site or you have been to it, but you cannot figure out what it is or what it can do. MTA web directory is the simplest way in which one can bid on a link, or a few links if they wish to do so. The link directory on MTA displays all of the links it currently has, and does so in alphabetical order, which makes it much easier for someone to find what they are looking for if it is something specific and they do not want to go through all the other sites and links as well. It allows you to start your bid at the bottom and slowly work";

  const location = _mock.fullAddress(index);
  const city = countries.map((option) => option.label)[index];
  const matches = TOURNAMENT_MATCHES;
  const venues = TOURNAMENT_VENUES;
  const type = index % 2 ? "championship" : "tournament";
  const provider_urltag = "testprovider";
  // const venues = [1, 2, 3, 4];
  return {
    id: index,
    provider_id: 1,
    avatarUrl,
    coverUrl,
    images,
    publish,
    city,
    type,
    provider_urltag,
    registrationPeriod,

    location,
    start_date: _mock.time(index + 1),
    end_Date: _mock.time(index),

    name: _mock.tourName(index),
    created_at: _mock.time(index),
    status,
    sports,
    organiser,
    judges,
    ball,
    prize,
    description,
    matches,
    venues,
  };
});

import dayjs from "dayjs";
import {
  ITournamentCreateData,
  TournamentFormData,
} from "src/types/tournament";

export const MOCK_TOURNAMENT_DEFAULT_VALUES: TournamentFormData = {
  id: 0,
  provider_id: 69,
  name: "Tavaszi Kupa 2026",
  content: "",
  description:
    "Egy tavaszi amatőr torna több kategóriában, csoportkörrel és főtáblával.",
  cover_image: "https://picsum.photos/1200/600?random=11",
  gallery: [],
  status: "draft",
  start_date: new Date("2026-04-12 09:00:00"),
  end_date: new Date("2026-04-13 18:00:00"),
  applications_open_at: new Date("2026-03-15 08:00:00"),
  applications_close_at: new Date("2026-04-08 20:00:00"),
  is_public: true,
  city: "debrecen",
  location: "DEAC Teniszcentrum, Debrecen",
  organiser: "FoggoSport",
  judges: "Kiss Péter, Nagy Anna",
  ball: "Wilson US Open",
  prize: "Kupák, érmek, ajándékcsomagok",
  categories: [
    {
      _key: "mock_cat_1",
      template_id: null,
      name: "Férfi egyéni A",
      sport: "tennis",
      order: 1,
      gender_rule: "male",
      age_min: null,
      age_max: null,
      birthyear_min: null,
      birthyear_max: null,
      skill_level_min: null,
      skill_level_max: null,
      discipline: "singles",
      team_size: null,
      mixed_rule: "",
      age_bracket_tag: null,
      rules_json: {},
      entry_fee_cents: 5000,
      max_entries: 16,
      is_active: true,
    },
    {
      _key: "mock_cat_2",
      template_id: null,
      name: "Női egyéni",
      sport: "tennis",
      order: 2,
      gender_rule: "female",
      age_min: null,
      age_max: null,
      birthyear_min: null,
      birthyear_max: null,
      skill_level_min: null,
      skill_level_max: null,
      discipline: "singles",
      team_size: null,
      mixed_rule: "",
      age_bracket_tag: null,
      rules_json: {},
      entry_fee_cents: 5000,
      max_entries: 16,
      is_active: true,
    },
    {
      _key: "mock_cat_3",
      template_id: null,
      name: "Férfi páros",
      sport: "tennis",
      order: 3,
      gender_rule: "open",
      age_min: null,
      age_max: null,
      birthyear_min: null,
      birthyear_max: null,
      skill_level_min: null,
      skill_level_max: null,
      discipline: "doubles",
      team_size: null,
      mixed_rule: "",
      age_bracket_tag: null,
      rules_json: {},
      entry_fee_cents: 8000,
      max_entries: 8,
      is_active: true,
    },
  ] as any[],
};
